import axios from 'axios';

/**
 * @function detectTouchSupport
 * Detect whether or not user's device support touch events
 * NOTE: This is not guaranteed to be accurate in 100% of cases!
 * @return {bool}
 */
export function detectTouchSupport () {
	return (
		( window.hasOwnProperty('ontouchstart') )
		|| (window.DocumentTouch && document instanceof window.DocumentTouch)
		|| navigator.maxTouchPoints > 0
		|| window.navigator.msMaxTouchPoints > 0
	);
}

/**
 * @function getWidgetTypeClass
 * Generate a class name for a public site widget from its "type" attribute
 * @param  {string} type
 * @return {string}
 */
export function getWidgetTypeClass (type) {
	return type.toLowerCase().replace('_', '-');
}

/**
 * @function readOnly
 * Make the properties of the passed object read-only
 * @param  {object} props
 * @return {object}
 */
export function readOnly (obj) {
	let readOnlyObj = {};

	Object.keys(obj).forEach(prop => {
		Object.defineProperty(readOnlyObj, prop, {
			configurable: false,
			enumerable: false,
			writable: false,
			value: obj[prop]
		})
	});

	return readOnlyObj;
}

/**
 * @function request
 * wrapper for axios
 * @param {object} body
 * see axios docs for object shape: https://github.com/mzabriskie/axios
 * @param {boolean} bustCache
 * Append timestamp to request url if true
 * @return {promise}
 */
export function request (request, bustCache = false) {
	if (bustCache) {
		request.url = `${request.url}?${new Date().getTime()}`;
	}

	return axios(request);
}

/**
 * @function percentageToCoords
 * Convert a set of percentage-based CSS position values to pixel coordinates to
 * determine the start position of a widget when beginning a reposition operation
 * @param  {object} dragLayer
 * boundingClientRect of Drag Layer (The area in which a widget can be dragged)
 * @param  {object} widget
 * Widget data passed by react-dnd during reposition operation
 * @return {object}
 * Contains top and left coordinates for the top-left corner of the widget
 */
export function percentageToCoords (dragLayer, widget) {
	const startingPosition = {};

	Object.keys(widget.position).forEach(key => {
		let percentage = widget.position[key] / 100;

		switch (key) {
			case 'top':
				startingPosition.top = dragLayer.height * percentage;
				break;

			case 'right':
				startingPosition.left = (dragLayer.width - (dragLayer.width * percentage)) - widget.dimensions.width;
				break;

			case 'bottom':
				startingPosition.top = (dragLayer.height - (dragLayer.height * percentage)) - widget.dimensions.height;
				break;

			case 'left':
				startingPosition.left = dragLayer.width * percentage;
				break;

			default:
				return;
		};
	});

	return startingPosition;
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/shared/utilities.js